import React, { useState } from 'react';
import {
  Box, Typography, Container, Button, Alert,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { collection, addDoc } from 'firebase/firestore';
import Footer from '../landingPage/footerSection/Footer';
import { db } from '../../firebase/firebase';

const ApplicationForm = () => {
  const [success, setSuccess] = useState(false);
  const [first, setFirst] = useState('');
  const [last, setLast] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [status, setStatus] = useState('');

  const navigate = useNavigate();

  const handleEnroll = () => {
    navigate('/');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const colRef = collection(db, 'applications');
    await addDoc(colRef, {
      firstName: first,
      lastName: last,
      email,
      phone,
      status,
    })
      .then(() => {
        setSuccess(true);
      })
      .catch((err) => {
        setSuccess(false);
        alert(err.message);
      });

    setFirst('');
    setLast('');
    setEmail('');
    setPhone('');
    setStatus('');
  };

  return (
    <Container>
      <Box sx={{
        width: '90%', bgcolor: 'transparent', display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: 'center', margin: '70px auto',
      }}
      >
        <Box sx={{ width: { xs: '100%', sm: '41%' } }}>
          <Typography sx={{
            background: 'linear-gradient(to right, #F49867, #AE67FA)', textFillColor: 'transparent', backgroundClip: 'text', fontSize: { xs: '35px', sm: '50px' }, fontWeight: '600', lineHeight: { xs: '40px', sm: '70px' },
          }}
          >
            Fill Out This Application For Our Next Cohort.
          </Typography>
          <Typography sx={{
            color: '#71E5FF', lineHeight: 'auto', padding: '20px 0', fontSize: '12',
          }}
          >
            Our team will respond within 24hrs
          </Typography>
        </Box>
        { !success
          ? (
            <Box sx={{ width: { xs: '100%', sm: '58%' } }}>
              <form
                onSubmit={handleSubmit}
                style={{
                  width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: '10px',
                }}
              >
                <input
                  onChange={(e) => setFirst(e.target.value)}
                  value={first}
                  style={{
                    width: '100%', padding: '15px', border: '2px solid #F49867', color: '#AE67FA', borderRadius: '5px', outline: 'none', background: 'transparent',
                  }}
                  type="text"
                  placeholder="Your First Name"
                />
                <input
                  onChange={(e) => setLast(e.target.value)}
                  value={last}
                  style={{
                    width: '100%', padding: '15px', border: '2px solid #F49867', color: '#AE67FA', borderRadius: '5px', outline: 'none', background: 'transparent',
                  }}
                  type="text"
                  placeholder="Your Last Name"
                />
                <input
                  onChange={(e) => setEmail(e.target.value)}
                  value={email}
                  style={{
                    width: '100%', padding: '15px', border: '2px solid #F49867', color: '#AE67FA', borderRadius: '5px', outline: 'none', background: 'transparent',
                  }}
                  type="email"
                  placeholder="Your Email"
                />
                <input
                  onChange={(e) => setPhone(e.target.value)}
                  value={phone}
                  style={{
                    width: '100%', padding: '15px', border: '2px solid #F49867', color: '#AE67FA', borderRadius: '5px', outline: 'none', background: 'transparent',
                  }}
                  type="number"
                  placeholder="Your Phone"
                />
                <input
                  onChange={(e) => setStatus(e.target.value)}
                  value={status}
                  style={{
                    width: '100%', padding: '15px', border: '2px solid #F49867', color: '#AE67FA', borderRadius: '5px', outline: 'none', background: 'transparent',
                  }}
                  type="text"
                  placeholder="Are you a parent or student?"
                />
                <button
                  style={{
                    background: 'linear-gradient(to right, #AE67FA, #F49867)', cursor: 'pointer', color: '#fff', outline: 'none', borderRadius: '5px', width: '100%', padding: '12px', border: 'none', fontWeight: '400',
                  }}
                  type="submit"
                >
                  Enroll Now
                </button>
              </form>
            </Box>
          )
          : (
            <Box sx={{ width: { xs: '100%', sm: '55%' } }}>
              <Alert severity="success">Your application was submitted successfully! We will reach out within 24hrs</Alert>
            </Box>
          )}
      </Box>

      <Box sx={{
        width: '100%', background: 'linear-gradient(to right, #AE67FA, #F49867)', padding: '40px', borderRadius: '5px', margin: '100px 0', display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'center', alignItems: { xs: 'start', sm: 'center' },
      }}
      >
        <Box sx={{ width: '70%' }}>
          <Typography sx={{ color: '#000', fontWeight: '400', padding: '10px 0' }}>We Enroll A New Cohort On The 15th of Each Month</Typography>
          <Typography sx={{ color: '#000', fontWeight: '400', fontSize: '20px' }}>Tuition for all our programs is $45 billed monthly</Typography>
        </Box>
        <Box sx={{ width: '20%' }}>
          <Button
            onClick={handleEnroll}
            variant="contained"
            sx={{
              backgroundColor: '#000', color: '#fff', '&:hover': { background: '#fff', color: '#000' }, padding: '8px 35px', borderRadius: '20px',
            }}
          >
            BACK TO WEBSITE
          </Button>
        </Box>
      </Box>
      <Footer />
    </Container>
  );
};

export default ApplicationForm;
